// Translations for POM Property Management Website

export const translations = {
  en: {
    // Header
    nav: {
      home: "Home",
      services: "Services",
      packages: "Packages",
      blog: "Discover Puerto Plata",
      revenueCalculator: "Revenue Calculator",
      currencyConverter: "Currency Converter",
      contact: "Contact",
      getStarted: "Get Started"
    },
    slangOfDay: "Slang of the Day",
    
    // Hero Section
    hero: {
      badge: "Puerto Plata & Las Terrenas, DR",
      title1: "POM Property Management",
      title2: "Peace of Mind for Property Owners",
      subtitle: "Experience true",
      peaceOfMind: "Peace of Mind",
      subtitleEnd: "with expert property management in paradise. 20+ years of local expertise caring for your investment.",
      superHost: "Airbnb Superhost",
      noGringo: 'No "Gringo Taxes"',
      viewPackages: "View Packages",
      contactUs: "Contact Us",
      packagesStart: "Airbnb Rental Management starts as low as"
    },
    
    // Features Section
    features: {
      badge: "Why Choose Us",
      title1: "Caribbean Expertise,",
      title2: "World-Class Service",
      subtitle: "With over 20 years of experience in Puerto Plata and Las Terrenas luxury vacation business, we bring unmatched local knowledge to every property we manage.",
      alaCarte: "À La Carte Services",
      alaCarteSubtitle: "Add any of these services to your package",
      items: {
        multilingual: "Multilingual Team",
        multilingualDesc: "Fluent in English, Spanish, and French",
        noGringo: "No Gringo Taxes",
        noGringoDesc: "Fair, transparent pricing for everyone",
        experience: "20+ Years Experience",
        experienceDesc: "Local experts in luxury vacation business",
        sparkly: "Sparkly Clean",
        sparklyDesc: "No cutting corners on quality"
      },
      services: {
        deepCleaning: "Deep Cleaning",
        airportTransfers: "Airport Transfers",
        poolMaintenance: "Pool Maintenance",
        lawnGarden: "Lawn & Garden Service",
        pestControl: "Pest Control",
        expensesTracking: "Expenses Tracking"
      }
    },
    
    // Packages Section
    packages: {
      badge: "Our Packages",
      title1: "Tailored Solutions for",
      title2: "Every Property",
      subtitle: "From absentee homeowners to luxury rental hosts, we have the perfect package for you.",
      priceStart: "Airbnb Rental Management starts as low as 15%/month",
      mostPopular: "MOST POPULAR",
      multiProperty: "Multi-Property Discounts Available!",
      multiPropertyDesc: "5% off for 2-3 properties • 10% off for 4+ properties",
      learnMore: "Learn More",
      essential: {
        name: "Essential Care Package",
        target: "For Absentee Homeowners",
        highlight: "Perfect for 2-3 bedroom homes"
      },
      rental: {
        name: "Rental Management Package",
        target: "For Short-term Rentals & Airbnb Hosts",
        highlight: "Elevate to SuperHost status"
      },
      premium: {
        name: "Premium Concierge Package",
        target: "For Luxury & High-end Rentals",
        highlight: "White-glove service experience"
      },
      features: {
        billPayments: "Bill payments (utilities, HOA, taxes)",
        monthlyDeep: "Monthly Deep Cleaning",
        emergency: "Emergency contact for property issues",
        inspection: "Monthly property inspection & report",
        keyHolding: "Key holding service",
        airportTransfer: "Airport Transfer from POP (Special Promo)",
        everythingEssential: "Everything in Essential Care, plus:",
        listingManagement: "Airbnb/Booking.com/VRBO listing management",
        guestComm: "Guest communication & support",
        checkInOut: "Check-in & check-out service",
        professionalCleaning: "Professional cleaning & turnover",
        welcomeKit: "Guest welcome kit",
        support247: "24/7 guest support hotline",
        everythingRental: "Everything in Rental Management, plus:",
        airportCoord: "Airport pick-up/drop-off coordination",
        groceries: "Stocking groceries & supplies",
        excursions: "Excursions, tours & car rentals",
        handyman: "On-call handyman services",
        vipConcierge: "VIP guest concierge services",
        restaurantBookings: "Restaurant, private chef & spa bookings"
      }
    },
    
    // Slang Section
    slang: {
      badge: "Learn Dominican Spanish",
      title: "Word of the Day",
      subtitle: "Impress the locals! Learn a new Dominican slang word every day.",
      example: "Example:",
      funFact: "Fun Fact:",
      newWord: "New Word",
      comeBack: "Come back tomorrow for\na new word!"
    },
    
    // Blog Section
    blog: {
      badge: "Our Blog",
      title: "Discover Puerto Plata",
      subtitle: "Explore the hidden gems, local culture, and tropical adventures that make Puerto Plata a paradise worth discovering.",
      readMore: "Read More",
      viewAll: "View All Articles",
      categories: {
        beaches: "Beaches",
        foodCulture: "Food & Culture",
        adventures: "Adventures",
        attractions: "Attractions"
      },
      posts: {
        beaches: {
          title: "Top 10 Hidden Beaches in Puerto Plata",
          excerpt: "Discover secluded paradises away from the tourist crowds. From pristine shores to crystal-clear waters..."
        },
        food: {
          title: "A Food Lover's Guide to Dominican Cuisine",
          excerpt: "From sancocho to mangu, explore the rich flavors of Dominican cooking and where to find the best local dishes..."
        },
        waterfalls: {
          title: "The 27 Waterfalls of Damajagua",
          excerpt: "Adventure awaits at this stunning natural wonder. Learn how to plan your perfect waterfall adventure..."
        },
        teleferico: {
          title: "Puerto Plata's Historic Teleférico",
          excerpt: "Ride the only cable car in the Caribbean and enjoy breathtaking views of the Atlantic Ocean..."
        }
      }
    },
    
    // Contact Section
    contact: {
      badge: "Get in Touch",
      title: "Ready for Peace of Mind?",
      subtitle: "Let's discuss how we can help you manage your property in Puerto Plata or Las Terrenas. Reach out today for a free consultation.",
      info: "Contact Information",
      location: "Location",
      phone: "Phone",
      email: "Email",
      hours: "Business Hours",
      hoursWeek: "Monday - Saturday: 9AM - 6PM",
      hoursSun: "Sunday: Emergency Only",
      yearsExp: "Years Experience",
      languages: "Languages Spoken",
      form: {
        fullName: "Full Name",
        email: "Email",
        phone: "Phone",
        propertyType: "Property Type",
        selectProperty: "Select property type",
        apartment: "Apartment",
        villa: "Villa",
        condo: "Condo",
        house: "House",
        other: "Other",
        message: "Message",
        messagePlaceholder: "Tell us about your property and what services you're interested in...",
        send: "Send Message",
        success: "Message Sent!",
        successMsg: "Thank you for reaching out. We'll get back to you within 24 hours."
      }
    },
    
    // Footer
    footer: {
      description: "Your trusted partner for property management in Puerto Plata and Las Terrenas. 20+ years of local expertise serving international property owners.",
      quickLinks: "Quick Links",
      services: "Services",
      contactUs: "Contact Us",
      rights: "All rights reserved.",
      madeWith: "Made with",
      inPuertoPlata: "in Puerto Plata & Las Terrenas"
    },

    // Currency Converter
    currency: {
      badge: "Currency Tool",
      title: "Currency Converter",
      subtitle: "Convert USD, CAD, or EUR to Dominican Pesos (DOP)",
      subtitle2: "Convert between USD, CAD, EUR and Dominican Pesos (DOP)",
      amount: "Amount",
      from: "From",
      to: "To",
      currentRates: "Current Exchange Rates",
      refresh: "Refresh Rates",
      lastUpdated: "Last updated",
      disclaimer: "Exchange rates are for reference only. Actual rates may vary."
    },

    // Revenue Calculator
    revenue: {
      badge: "Investment Tool",
      title: "Airbnb Revenue Calculator",
      subtitle: "Estimate your potential rental income in the Dominican Republic",
      propertyDetails: "Property Details",
      selectArea: "Select Area",
      propertyType: "Property Type",
      bedrooms: "Number of Bedrooms",
      occupancy: "Expected Occupancy Rate",
      occupancyTip: "Occupancy Tips",
      tip1: "New listings: 40-50% in first year",
      tip2: "Established listings: 60-75%",
      tip3: "SuperHost status can boost by 10-15%",
      estimatedRevenue: "Estimated Revenue",
      yearlyRevenue: "Estimated Yearly Revenue",
      perYear: "per year",
      monthlyAvg: "Monthly Average",
      nightlyRate: "Nightly Rate",
      seasonalRates: "Seasonal Rate Estimates",
      highSeason: "High Season",
      regularSeason: "Regular Season",
      lowSeason: "Low Season",
      occupiedNights: "Occupied nights/month",
      nights: "nights",
      ctaText: "Let us help you maximize your rental income",
      getStarted: "Get Property Management Quote",
      disclaimer: "Estimates are based on market averages and may vary. Actual revenue depends on property condition, amenities, reviews, and market conditions.",
      propertyTypes: {
        studio: "Studio",
        apartment: "Apartment",
        condo: "Condo",
        villa: "Villa",
        house: "House"
      }
    }
  },
  
  es: {
    // Header
    nav: {
      home: "Inicio",
      services: "Servicios",
      packages: "Paquetes",
      blog: "Descubre Puerto Plata",
      revenueCalculator: "Calculadora de Ingresos",
      currencyConverter: "Convertidor de Moneda",
      contact: "Contacto",
      getStarted: "Comenzar"
    },
    slangOfDay: "Jerga del Día",
    
    // Hero Section
    hero: {
      badge: "Puerto Plata & Las Terrenas, RD",
      title1: "POM Property Management",
      title2: "Tranquilidad para Propietarios",
      subtitle: "Experimenta la verdadera",
      peaceOfMind: "Tranquilidad",
      subtitleEnd: "con gestión experta de propiedades en el paraíso. Más de 20 años de experiencia local cuidando tu inversión.",
      superHost: "Airbnb Superhost",
      noGringo: 'Sin "Impuestos de Gringo"',
      viewPackages: "Ver Paquetes",
      contactUs: "Contáctanos",
      packagesStart: "Gestión de Alquileres Airbnb desde"
    },
    
    // Features Section
    features: {
      badge: "Por Qué Elegirnos",
      title1: "Experiencia Caribeña,",
      title2: "Servicio de Clase Mundial",
      subtitle: "Con más de 20 años de experiencia en el negocio de vacaciones de lujo en Puerto Plata y Las Terrenas, aportamos un conocimiento local inigualable a cada propiedad que gestionamos.",
      alaCarte: "Servicios À La Carte",
      alaCarteSubtitle: "Añade cualquiera de estos servicios a tu paquete",
      items: {
        multilingual: "Equipo Multilingüe",
        multilingualDesc: "Fluidos en inglés, español y francés",
        noGringo: "Sin Impuestos de Gringo",
        noGringoDesc: "Precios justos y transparentes para todos",
        experience: "20+ Años de Experiencia",
        experienceDesc: "Expertos locales en negocios de vacaciones de lujo",
        sparkly: "Limpieza Impecable",
        sparklyDesc: "Sin recortar en calidad"
      },
      services: {
        deepCleaning: "Limpieza Profunda",
        airportTransfers: "Traslados al Aeropuerto",
        poolMaintenance: "Mantenimiento de Piscina",
        lawnGarden: "Servicio de Jardín",
        pestControl: "Control de Plagas",
        expensesTracking: "Seguimiento de Gastos"
      }
    },
    
    // Packages Section
    packages: {
      badge: "Nuestros Paquetes",
      title1: "Soluciones Personalizadas para",
      title2: "Cada Propiedad",
      subtitle: "Desde propietarios ausentes hasta anfitriones de alquileres de lujo, tenemos el paquete perfecto para ti.",
      priceStart: "Gestión de Alquileres Airbnb desde 15%/mes",
      mostPopular: "MÁS POPULAR",
      multiProperty: "¡Descuentos por Múltiples Propiedades!",
      multiPropertyDesc: "5% de descuento para 2-3 propiedades • 10% para 4+ propiedades",
      learnMore: "Más Información",
      essential: {
        name: "Paquete Cuidado Esencial",
        target: "Para Propietarios Ausentes",
        highlight: "Perfecto para casas de 2-3 habitaciones"
      },
      rental: {
        name: "Paquete Gestión de Alquileres",
        target: "Para Alquileres a Corto Plazo y Airbnb",
        highlight: "Elévate al estatus de SuperHost"
      },
      premium: {
        name: "Paquete Concierge Premium",
        target: "Para Alquileres de Lujo",
        highlight: "Experiencia de servicio exclusivo"
      },
      features: {
        billPayments: "Pago de facturas (servicios, HOA, impuestos)",
        monthlyDeep: "Limpieza Profunda Mensual",
        emergency: "Contacto de emergencia para problemas",
        inspection: "Inspección mensual e informe de propiedad",
        keyHolding: "Servicio de custodia de llaves",
        airportTransfer: "Traslado desde POP (Promo Especial)",
        everythingEssential: "Todo en Cuidado Esencial, más:",
        listingManagement: "Gestión de Airbnb/Booking.com/VRBO",
        guestComm: "Comunicación y soporte al huésped",
        checkInOut: "Servicio de check-in y check-out",
        professionalCleaning: "Limpieza profesional entre huéspedes",
        welcomeKit: "Kit de bienvenida para huéspedes",
        support247: "Línea de soporte 24/7",
        everythingRental: "Todo en Gestión de Alquileres, más:",
        airportCoord: "Coordinación de traslados aeropuerto",
        groceries: "Abastecimiento de comestibles",
        excursions: "Excursiones, tours y alquiler de autos",
        handyman: "Servicios de mantenimiento a demanda",
        vipConcierge: "Servicios de concierge VIP",
        restaurantBookings: "Reservas de restaurantes, chef y spa"
      }
    },
    
    // Slang Section
    slang: {
      badge: "Aprende Español Dominicano",
      title: "Palabra del Día",
      subtitle: "¡Impresiona a los locales! Aprende una nueva palabra de jerga dominicana cada día.",
      example: "Ejemplo:",
      funFact: "Dato Curioso:",
      newWord: "Nueva Palabra",
      comeBack: "¡Vuelve mañana para\nuna nueva palabra!"
    },
    
    // Blog Section
    blog: {
      badge: "Nuestro Blog",
      title: "Descubre Puerto Plata",
      subtitle: "Explora las joyas escondidas, la cultura local y las aventuras tropicales que hacen de Puerto Plata un paraíso que vale la pena descubrir.",
      readMore: "Leer Más",
      viewAll: "Ver Todos los Artículos",
      categories: {
        beaches: "Playas",
        foodCulture: "Comida y Cultura",
        adventures: "Aventuras",
        attractions: "Atracciones"
      },
      posts: {
        beaches: {
          title: "Las 10 Mejores Playas Escondidas de Puerto Plata",
          excerpt: "Descubre paraísos apartados lejos de las multitudes turísticas. Desde costas prístinas hasta aguas cristalinas..."
        },
        food: {
          title: "Guía Gastronómica de la Cocina Dominicana",
          excerpt: "Del sancocho al mangú, explora los ricos sabores de la cocina dominicana y dónde encontrar los mejores platos locales..."
        },
        waterfalls: {
          title: "Los 27 Charcos de Damajagua",
          excerpt: "La aventura te espera en esta impresionante maravilla natural. Aprende a planificar tu aventura perfecta en las cascadas..."
        },
        teleferico: {
          title: "El Histórico Teleférico de Puerto Plata",
          excerpt: "Sube al único teleférico del Caribe y disfruta de vistas impresionantes del Océano Atlántico..."
        }
      }
    },
    
    // Contact Section
    contact: {
      badge: "Contáctanos",
      title: "¿Listo para la Tranquilidad?",
      subtitle: "Hablemos de cómo podemos ayudarte a gestionar tu propiedad en Puerto Plata o Las Terrenas. Contáctanos hoy para una consulta gratuita.",
      info: "Información de Contacto",
      location: "Ubicación",
      phone: "Teléfono",
      email: "Correo",
      hours: "Horario de Atención",
      hoursWeek: "Lunes - Sábado: 9AM - 6PM",
      hoursSun: "Domingo: Solo Emergencias",
      yearsExp: "Años de Experiencia",
      languages: "Idiomas Hablados",
      form: {
        fullName: "Nombre Completo",
        email: "Correo Electrónico",
        phone: "Teléfono",
        propertyType: "Tipo de Propiedad",
        selectProperty: "Selecciona tipo de propiedad",
        apartment: "Apartamento",
        villa: "Villa",
        condo: "Condominio",
        house: "Casa",
        other: "Otro",
        message: "Mensaje",
        messagePlaceholder: "Cuéntanos sobre tu propiedad y qué servicios te interesan...",
        send: "Enviar Mensaje",
        success: "¡Mensaje Enviado!",
        successMsg: "Gracias por contactarnos. Te responderemos en 24 horas."
      }
    },
    
    // Footer
    footer: {
      description: "Tu socio de confianza para la gestión de propiedades en Puerto Plata y Las Terrenas. Más de 20 años de experiencia local sirviendo a propietarios internacionales.",
      quickLinks: "Enlaces Rápidos",
      services: "Servicios",
      contactUs: "Contáctanos",
      rights: "Todos los derechos reservados.",
      madeWith: "Hecho con",
      inPuertoPlata: "en Puerto Plata & Las Terrenas"
    },

    // Currency Converter
    currency: {
      badge: "Herramienta de Moneda",
      title: "Convertidor de Moneda",
      subtitle: "Convierte USD, CAD o EUR a Pesos Dominicanos (DOP)",
      subtitle2: "Convierte entre USD, CAD, EUR y Pesos Dominicanos (DOP)",
      amount: "Cantidad",
      from: "De",
      to: "A",
      currentRates: "Tasas de Cambio Actuales",
      refresh: "Actualizar Tasas",
      lastUpdated: "Última actualización",
      disclaimer: "Las tasas de cambio son solo de referencia. Las tasas reales pueden variar."
    },

    // Revenue Calculator
    revenue: {
      badge: "Herramienta de Inversión",
      title: "Calculadora de Ingresos Airbnb",
      subtitle: "Estima tus ingresos potenciales de alquiler en República Dominicana",
      propertyDetails: "Detalles de la Propiedad",
      selectArea: "Seleccionar Área",
      propertyType: "Tipo de Propiedad",
      bedrooms: "Número de Habitaciones",
      occupancy: "Tasa de Ocupación Esperada",
      occupancyTip: "Consejos de Ocupación",
      tip1: "Nuevos anuncios: 40-50% en el primer año",
      tip2: "Anuncios establecidos: 60-75%",
      tip3: "Estado SuperHost puede aumentar 10-15%",
      estimatedRevenue: "Ingresos Estimados",
      yearlyRevenue: "Ingresos Anuales Estimados",
      perYear: "por año",
      monthlyAvg: "Promedio Mensual",
      nightlyRate: "Tarifa por Noche",
      seasonalRates: "Tarifas por Temporada",
      highSeason: "Temporada Alta",
      regularSeason: "Temporada Regular",
      lowSeason: "Temporada Baja",
      occupiedNights: "Noches ocupadas/mes",
      nights: "noches",
      ctaText: "Permítenos ayudarte a maximizar tus ingresos de alquiler",
      getStarted: "Obtener Cotización de Gestión",
      disclaimer: "Las estimaciones se basan en promedios del mercado y pueden variar. Los ingresos reales dependen de la condición de la propiedad, amenidades, reseñas y condiciones del mercado.",
      propertyTypes: {
        studio: "Estudio",
        apartment: "Apartamento",
        condo: "Condominio",
        villa: "Villa",
        house: "Casa"
      }
    }
  },
  
  fr: {
    // Header
    nav: {
      home: "Accueil",
      services: "Services",
      packages: "Forfaits",
      blog: "Découvrir Puerto Plata",
      revenueCalculator: "Calculateur de Revenus",
      currencyConverter: "Convertisseur de Devises",
      contact: "Contact",
      getStarted: "Commencer"
    },
    slangOfDay: "Argot du Jour",
    
    // Hero Section
    hero: {
      badge: "Puerto Plata & Las Terrenas, RD",
      title1: "POM Property Management",
      title2: "Tranquillité d'Esprit pour Propriétaires",
      subtitle: "Découvrez la vraie",
      peaceOfMind: "Tranquillité d'Esprit",
      subtitleEnd: "avec une gestion experte de propriétés au paradis. Plus de 20 ans d'expertise locale pour protéger votre investissement.",
      superHost: "Airbnb Superhost",
      noGringo: 'Pas de "Taxes Gringo"',
      viewPackages: "Voir les Forfaits",
      contactUs: "Contactez-nous",
      packagesStart: "Gestion de Location Airbnb à partir de"
    },
    
    // Features Section
    features: {
      badge: "Pourquoi Nous Choisir",
      title1: "Expertise Caribéenne,",
      title2: "Service de Classe Mondiale",
      subtitle: "Avec plus de 20 ans d'expérience dans le secteur des vacances de luxe à Puerto Plata et Las Terrenas, nous apportons une connaissance locale inégalée à chaque propriété que nous gérons.",
      alaCarte: "Services À La Carte",
      alaCarteSubtitle: "Ajoutez ces services à votre forfait",
      items: {
        multilingual: "Équipe Multilingue",
        multilingualDesc: "Couramment en anglais, espagnol et français",
        noGringo: "Pas de Taxes Gringo",
        noGringoDesc: "Tarification juste et transparente pour tous",
        experience: "20+ Ans d'Expérience",
        experienceDesc: "Experts locaux en vacances de luxe",
        sparkly: "Propreté Impeccable",
        sparklyDesc: "Aucun compromis sur la qualité"
      },
      services: {
        deepCleaning: "Nettoyage en Profondeur",
        airportTransfers: "Transferts Aéroport",
        poolMaintenance: "Entretien de Piscine",
        lawnGarden: "Service Jardin",
        pestControl: "Contrôle des Nuisibles",
        expensesTracking: "Suivi des Dépenses"
      }
    },
    
    // Packages Section
    packages: {
      badge: "Nos Forfaits",
      title1: "Solutions Sur Mesure pour",
      title2: "Chaque Propriété",
      subtitle: "Des propriétaires absents aux hôtes de locations de luxe, nous avons le forfait parfait pour vous.",
      priceStart: "Gestion de Location Airbnb à partir de 15%/mois",
      mostPopular: "PLUS POPULAIRE",
      multiProperty: "Réductions Multi-Propriétés Disponibles!",
      multiPropertyDesc: "5% de réduction pour 2-3 propriétés • 10% pour 4+ propriétés",
      learnMore: "En Savoir Plus",
      essential: {
        name: "Forfait Soins Essentiels",
        target: "Pour Propriétaires Absents",
        highlight: "Parfait pour maisons 2-3 chambres"
      },
      rental: {
        name: "Forfait Gestion Locative",
        target: "Pour Locations Court Terme & Airbnb",
        highlight: "Atteignez le statut SuperHost"
      },
      premium: {
        name: "Forfait Concierge Premium",
        target: "Pour Locations de Luxe",
        highlight: "Expérience service haut de gamme"
      },
      features: {
        billPayments: "Paiement des factures (services, HOA, taxes)",
        monthlyDeep: "Nettoyage en Profondeur Mensuel",
        emergency: "Contact d'urgence pour problèmes",
        inspection: "Inspection mensuelle et rapport",
        keyHolding: "Service de garde des clés",
        airportTransfer: "Transfert depuis POP (Promo Spéciale)",
        everythingEssential: "Tout dans Soins Essentiels, plus:",
        listingManagement: "Gestion Airbnb/Booking.com/VRBO",
        guestComm: "Communication et support client",
        checkInOut: "Service check-in et check-out",
        professionalCleaning: "Nettoyage professionnel entre séjours",
        welcomeKit: "Kit de bienvenue pour invités",
        support247: "Assistance 24h/24 7j/7",
        everythingRental: "Tout dans Gestion Locative, plus:",
        airportCoord: "Coordination transferts aéroport",
        groceries: "Approvisionnement courses",
        excursions: "Excursions, tours et location auto",
        handyman: "Services de maintenance à la demande",
        vipConcierge: "Services concierge VIP",
        restaurantBookings: "Réservations restaurant, chef et spa"
      }
    },
    
    // Slang Section
    slang: {
      badge: "Apprenez l'Espagnol Dominicain",
      title: "Mot du Jour",
      subtitle: "Impressionnez les locaux! Apprenez un nouveau mot d'argot dominicain chaque jour.",
      example: "Exemple:",
      funFact: "Le Saviez-vous:",
      newWord: "Nouveau Mot",
      comeBack: "Revenez demain pour\nun nouveau mot!"
    },
    
    // Blog Section
    blog: {
      badge: "Notre Blog",
      title: "Découvrir Puerto Plata",
      subtitle: "Explorez les trésors cachés, la culture locale et les aventures tropicales qui font de Puerto Plata un paradis à découvrir.",
      readMore: "Lire Plus",
      viewAll: "Voir Tous les Articles",
      categories: {
        beaches: "Plages",
        foodCulture: "Cuisine et Culture",
        adventures: "Aventures",
        attractions: "Attractions"
      },
      posts: {
        beaches: {
          title: "Top 10 des Plages Cachées de Puerto Plata",
          excerpt: "Découvrez des paradis isolés loin des foules touristiques. Des rivages immaculés aux eaux cristallines..."
        },
        food: {
          title: "Guide Gastronomique de la Cuisine Dominicaine",
          excerpt: "Du sancocho au mangu, explorez les saveurs riches de la cuisine dominicaine et où trouver les meilleurs plats locaux..."
        },
        waterfalls: {
          title: "Les 27 Cascades de Damajagua",
          excerpt: "L'aventure vous attend dans cette merveille naturelle. Apprenez à planifier votre aventure parfaite aux cascades..."
        },
        teleferico: {
          title: "Le Téléphérique Historique de Puerto Plata",
          excerpt: "Montez dans le seul téléphérique des Caraïbes et profitez de vues imprenables sur l'océan Atlantique..."
        }
      }
    },
    
    // Contact Section
    contact: {
      badge: "Contactez-nous",
      title: "Prêt pour la Tranquillité?",
      subtitle: "Discutons de la façon dont nous pouvons vous aider à gérer votre propriété à Puerto Plata ou Las Terrenas. Contactez-nous aujourd'hui pour une consultation gratuite.",
      info: "Informations de Contact",
      location: "Emplacement",
      phone: "Téléphone",
      email: "Email",
      hours: "Heures d'Ouverture",
      hoursWeek: "Lundi - Samedi: 9h - 18h",
      hoursSun: "Dimanche: Urgences Uniquement",
      yearsExp: "Années d'Expérience",
      languages: "Langues Parlées",
      form: {
        fullName: "Nom Complet",
        email: "Email",
        phone: "Téléphone",
        propertyType: "Type de Propriété",
        selectProperty: "Sélectionnez le type de propriété",
        apartment: "Appartement",
        villa: "Villa",
        condo: "Condo",
        house: "Maison",
        other: "Autre",
        message: "Message",
        messagePlaceholder: "Parlez-nous de votre propriété et des services qui vous intéressent...",
        send: "Envoyer le Message",
        success: "Message Envoyé!",
        successMsg: "Merci de nous avoir contactés. Nous vous répondrons dans les 24 heures."
      }
    },
    
    // Footer
    footer: {
      description: "Votre partenaire de confiance pour la gestion immobilière à Puerto Plata et Las Terrenas. Plus de 20 ans d'expertise locale au service des propriétaires internationaux.",
      quickLinks: "Liens Rapides",
      services: "Services",
      contactUs: "Contactez-nous",
      rights: "Tous droits réservés.",
      madeWith: "Fait avec",
      inPuertoPlata: "à Puerto Plata & Las Terrenas"
    },

    // Currency Converter
    currency: {
      badge: "Outil de Devise",
      title: "Convertisseur de Devises",
      subtitle: "Convertissez USD, CAD ou EUR en Pesos Dominicains (DOP)",
      subtitle2: "Convertissez entre USD, CAD, EUR et Pesos Dominicains (DOP)",
      amount: "Montant",
      from: "De",
      to: "Vers",
      currentRates: "Taux de Change Actuels",
      refresh: "Actualiser les Taux",
      lastUpdated: "Dernière mise à jour",
      disclaimer: "Les taux de change sont fournis à titre indicatif uniquement. Les taux réels peuvent varier."
    },

    // Revenue Calculator
    revenue: {
      badge: "Outil d'Investissement",
      title: "Calculateur de Revenus Airbnb",
      subtitle: "Estimez vos revenus locatifs potentiels en République Dominicaine",
      propertyDetails: "Détails de la Propriété",
      selectArea: "Sélectionner la Zone",
      propertyType: "Type de Propriété",
      bedrooms: "Nombre de Chambres",
      occupancy: "Taux d'Occupation Prévu",
      occupancyTip: "Conseils d'Occupation",
      tip1: "Nouvelles annonces: 40-50% la première année",
      tip2: "Annonces établies: 60-75%",
      tip3: "Le statut SuperHost peut augmenter de 10-15%",
      estimatedRevenue: "Revenus Estimés",
      yearlyRevenue: "Revenus Annuels Estimés",
      perYear: "par an",
      monthlyAvg: "Moyenne Mensuelle",
      nightlyRate: "Tarif par Nuit",
      seasonalRates: "Tarifs Saisonniers",
      highSeason: "Haute Saison",
      regularSeason: "Saison Régulière",
      lowSeason: "Basse Saison",
      occupiedNights: "Nuits occupées/mois",
      nights: "nuits",
      ctaText: "Laissez-nous vous aider à maximiser vos revenus locatifs",
      getStarted: "Obtenir un Devis de Gestion",
      disclaimer: "Les estimations sont basées sur les moyennes du marché et peuvent varier. Les revenus réels dépendent de l'état de la propriété, des équipements, des avis et des conditions du marché.",
      propertyTypes: {
        studio: "Studio",
        apartment: "Appartement",
        condo: "Condo",
        villa: "Villa",
        house: "Maison"
      }
    }
  }
};

export default translations;
